import { Hero } from "../components/site/Hero";
import { Trust } from "../components/site/Trust";
import { Services } from "../components/site/Services";
import { Process } from "../components/site/Process";
import { Contact } from "../components/site/Contact";
import { Seo } from "../components/site/Seo";
import { SITE } from "../lib/site";

export default function HomePage() {
  const jsonLd = {
    "@context": "https://schema.org",
    "@type": "LocalBusiness",
    name: "Artı Bir Yapı",
    image: `https://${SITE.domain}/og.jpg`,
    telephone: SITE.phoneTel,
    address: {
      "@type": "PostalAddress",
      streetAddress: "Şerifali Mahallesi, İbrahim Hakkı Sokak No: 21/1",
      addressLocality: "Ümraniye",
      addressRegion: "İstanbul",
      addressCountry: "TR",
    },
    url: `https://${SITE.domain}`,
    priceRange: "₺₺",
    openingHours: "Mo-Sa 09:00-19:00",
    areaServed: { "@type": "City", name: "İstanbul" },
  };

  return (
    <>
      <Seo
        title="ARTIBİR | Ev, Daire ve Villa Tadilatı — İstanbul"
        description="Daire, villa ve yaşam alanlarında anahtar teslim tadilat, yenileme, dekorasyon, tesisat ve yalıtım uygulamaları. İstanbul genelinde ücretsiz keşif."
        keywords={[
          "ev tadilatı İstanbul",
          "daire tadilatı",
          "villa tadilatı",
          "anahtar teslim tadilat",
          "ev yenileme",
          "iç dekorasyon",
          "izolasyon",
          "çelik konstrüksiyon",
          "Ümraniye tadilat",
        ]}
        canonical={`https://${SITE.domain}/`}
        jsonLd={jsonLd}
      />
      <Hero />
      <Trust />
      <Services />
      <Process />
      <Contact />
    </>
  );
}
